<template>
  <div class="config_main_manage_background">
    <!-- 设置页面的内容区域 -->
    <div class="config_main_manage_page_wraper">
      <div class="config_main_manage_page_content">
        <!-- 设置页面收藏区域的内容区域样式   以上部分都是公共样式 -->
        <config-hang @click.native="autoSearchBtnHandle">
          <img slot="config_hang_ele1" src="~assets/img/config/zidongsousuo.png" alt />
          <span slot="config_hang_ele2">自动搜索</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>
        <config-hang @click.native="handAddHostBtnHandle">
          <img slot="config_hang_ele1" src="~assets/img/config/shoudongtianjia.png" alt />
          <!-- //代号20220220-6 -->
          <span slot="config_hang_ele2">手动绑定</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>

        <div v-if="bindHostState === 1">
          <!-- 判断是否有绑定的主机  有绑定的主机才显示下面的内容-->
          <config-hang @click.native="replaceHostBtnHandle">
            <img slot="config_hang_ele1" src="~assets/img/config/peiwang_hei.png" alt />
            <span slot="config_hang_ele2">更换主机</span>
            <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
          </config-hang>

          <config-title-hang>
            <span slot="config_title_hang_ele2">在线主机列表</span>
            <img slot="config_title_hang_ele5_img" src="~assets/img/config/shuaxin_bai.png" alt
              @click="shuaXinBtnHandle" />
            <span slot="config_title_hang_ele5" @click="shuaXinBtnHandle">刷新</span>
          </config-title-hang>

          <config-hang v-for="value in serveHostListData.onLineList" :key="value.gatewayId"
            @click.native="oneHostBtnHandle(value)">

            <!-- // 代号 20250209-1 -->
            <span slot="config_hang_ele2_1"
              :style="{ color: (value.errorInfo && value.errorInfo !== '') ? 'red' : '' }">
              {{ value.errorInfo && value.errorInfo !== '' ? '[' + value.errorInfo + ']' + value.gatewayTypeName :
                value.gatewayTypeName
              }}
            </span>
            <span slot="config_hang_ele2_2">
              [{{ value.borderAddress }}|{{ value.uniqueCode16 }}|{{ value.intranetIp }}]
            </span>
            <!-- <span slot="config_hang_ele3">{{ value.uniqueCode16 }}</span> -->
            <span slot="config_hang_ele3">{{ value.gatewayName }}</span>


            <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
          </config-hang>

          <config-title-hang v-if="serveHostListData.offLineList.length != 0">
            <span slot="config_title_hang_ele2">离线主机列表</span>
          </config-title-hang>

          <config-hang v-for="value in serveHostListData.offLineList" :key="value.gatewayId"
            @click.native="oneHostBtnHandle(value)">

            <!-- // 代号 20250209-1 -->
            <span slot="config_hang_ele2_1"
              :style="{ color: (value.errorInfo && value.errorInfo !== '') ? 'red' : '' }">
              {{ value.errorInfo && value.errorInfo !== '' ? '[' + value.errorInfo + ']' + value.gatewayTypeName :
                value.gatewayTypeName
              }}
            </span>
            <span slot="config_hang_ele2_2">
              [{{ value.borderAddress }}|{{ value.uniqueCode16 }}|{{ value.intranetIp }}]
            </span>
            <!-- <span slot="config_hang_ele3">{{ value.uniqueCode16 }}</span> -->
            <span slot="config_hang_ele3">{{ value.gatewayName }}</span>

            <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
          </config-hang>
        </div>
        <!-- <config-hang v-for="(value ) in serveHostListData.offLineList" :key="value.gatewayId">
          <span slot="config_hang_ele2">{{value.gatewayName}}</span>
          <span slot="config_hang_ele3">{{value.intranetIp}}</span>

          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang> -->
      </div>
    </div>
  </div>
</template>
<script>
// import topNav from "components/common/topnav/topnav";
// import topNavItem from "components/common/topnav/topnavitem";
import configTitleHang from 'components/common/config/config-title-hang'

import configHang from 'components/common/config/config-hang'
export default {
  data() {
    return {
      serveHostListData: {
        ////服务器请求到的主机列表
        offLineList: [],
        onLineList: []
      },
      bindHostState: 0 ///0未绑定任何主机设备   1绑定的有主机
    }
  },
  components: {
    // topNav,
    // topNavItem,
    configHang,
    configTitleHang
  },
  methods: {
    autoSearchBtnHandle() {
      ///自动搜索被点击了
      this.$router.push('autoSearchHost')
    },
    shuaXinBtnHandle() {
      ///刷新按钮被点击了
      /// 请求用户的网关列表接口，获取数据
      this.$request({
        method: 'post',
        url: '/gateway/findGatewayByUserList',
        data: {
          token: this.$store.state.token
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message)
            ////说明信息填写错误,控制失败了，
            return
          } else {
            ////、控制成功了
            this.serveHostListData = res.data.data ////拿到服务器返回的数据结果
            ////判断当前账号有没有主机被绑定
            if (
              this.serveHostListData.offLineList.length === 0 &&
              this.serveHostListData.onLineList.length === 0
            ) {
              ///说明当前账号没有主机被绑定
              this.bindHostState = 0
            } else {
              this.bindHostState = 1
            }
            this.$store.dispatch('asyUpdatabindHostState', this.bindHostState) ///异步提交信息到仓库  ///暂时没有用
            sessionStorage['bindHostState'] = this.bindHostState ////提交绑定主机状态到浏览器缓存

            // this.$showTipsToast(1, "获取成功", true); ////提示框
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    oneHostBtnHandle(value) {
      ////一个主机被点击了
      this.$router.push({
        path: 'addChangeHost',
        query: { type: 'change', uniqueCode16: value.uniqueCode16 }
      })
    },
    handAddHostBtnHandle() {
      ////手动添加主机被点击了
      this.$router.push('handAddHost')
    },
    replaceHostBtnHandle() {
      ///更换主机按钮被点击了
      this.$router.push('replaceHost')
    }
  },

  mounted() {
    console.log('mounted阶段')
  },
  created() {
    console.log('created阶段')
    /// 请求用户的网关列表接口，获取数据
    this.$request({
      method: 'post',
      url: '/gateway/findGatewayByUserList',
      data: {
        token: this.$store.state.token
      }
    })
      .then(res => {
        if (res.data.code != 0) {
          this.$showTipsToast(3, res.data.message)
          ////说明信息填写错误,控制失败了，
          return
        } else {
          ////、控制成功了
          this.serveHostListData = res.data.data ////拿到服务器返回的数据结果

          if (
            this.serveHostListData.offLineList.length === 0 &&
            this.serveHostListData.onLineList.length === 0
          ) {
            ///说明当前账号没有主机被绑定
            this.bindHostState = 0
          } else {
            this.bindHostState = 1
          }
          this.$store.dispatch('asyUpdatabindHostState', this.bindHostState) ///异步提交信息到仓库
          sessionStorage['bindHostState'] = this.bindHostState ////提交绑定主机状态到浏览器缓存
          // this.$showTipsToast(1, "获取成功", true); ////提示框
        }
      })
      .catch(error => {
        console.log(error)
      })
  }
}
</script>

<style></style>
